// initial state
const state = () => ({
  user: null,
  unread_messages_count: null,
  unseen_visitor_count: null,
});

// getters
const getters = {
  getUser: state => {
    return state.user;
  },
  getUserUnreadMessagesCount: state => {
    return state.unread_messages_count;
  },
  getUserUnseenVisitorCount: state => {
    return state.unseen_visitor_count;
  },
  getPrefFlag: state => {
    return state.user ? state.user.flags.PREF : null;
  },
  isPaymentApproved(state) {
    return function (args) {
      let approvals = state.user.payment_approvals;
      if (approvals === undefined || approvals === null) {
        return false;
      }
      return approvals[args];
    };
  }
};

// actions
const actions = {
  load({ commit }) {
    return axios.get('/ajax/user')
      .then(response => {
        commit('setUser', response.data.data);
        return true;
      })
      .catch(error => {
        return false;
      });
  },
};

// mutations
const mutations = {
  setUser: (state, user) => {
    state.user = user;
    state.unread_messages_count = user.unread_messages_count;
    state.unseen_visitor_count = user.unseen_visitor_count;
  },
  setUserUnreadMessagesCount: (state, unread_messages_count) => {
    state.unread_messages_count = unread_messages_count;
  },
  setUserUnseenVisitorCount: (state, unseen_visitor_count) => {
    state.unseen_visitor_count = unseen_visitor_count;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
